import React, { useState } from 'react';
import './Closed.css';

const orders = [
  { date: '06-08-2024', orderId: '12345', customerName: 'Rahul', category: 'Pick Up', details: 'View', paymentMethod: 'UPI', status: 'Completed', amount: '₹1500',Feedback:'Nice',Ratings:'* * * * *' },
  { date: '07-08-2024', orderId: '12345', customerName: 'Rahul', category: 'Dine In', details: 'View', paymentMethod: 'CASH', status: 'Completed', amount: '₹1500',Feedback:'Good',Ratings:'* * * * *' },
  { date: '08-08-2024', orderId: '12345', customerName: 'Rahul', category: 'Delivery', details: 'View', paymentMethod: 'CASH', status: 'Cancelled', amount: '₹1500',Feedback:'',Ratings:'* * *'},
  { date: '10-08-2024', orderId: '12345', customerName: 'Rahul', category: 'Pick Up', details: 'View', paymentMethod: 'WALLET', status: 'Cancelled', amount: '₹1500',Feedback:'',Ratings:'* * *' },
  { date: '10-08-2024', orderId: '12345', customerName: 'Rahul', category: 'Pick Up', details: 'View', paymentMethod: 'CARD', status: 'Cancelled', amount: '₹1500',Feedback:'',Ratings:'* * * *' },
];

const Modal = ({ show, onClose, content }) => {
  if (!show) return null;

  return (
    <div style={{borderRadius:"10px"}} className="modal-overlay">
      <div className="modal-content1">
        <button  className="close-btn" onClick={onClose}>X</button>
        <h4 style={{color:"#fff",marginBottom:"10px",marginLeft:"50px"}}>Order ID: #12345 <span style={{marginLeft:"20px"}}>26/03/2025,</span> <span>12:30pm</span></h4>
        <table className="order-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>Items</th>
            <th>Quantity</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody style={{fontWeight:"bold"}}>
          <tr>
            <td>1</td>
            <td>Chicken Biryani</td>
            <td>1</td>
            <td>₹150</td>
          </tr>
          <tr>
            <td>2</td>
            <td>Chicken 65</td>
            <td>3</td>
            <td>₹350</td>
          </tr>
        </tbody>
        </table>
      </div>
    </div>
  );
};

const Closed = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const handleViewClick = (details) => {
    setModalContent(details);
    setShowModal(true);
  };

  return (
    <div style={{overflowY:"auto",height:"550px",marginLeft:"-550px",width:"850px",scrollbarWidth:"none",marginTop:"10px"}}>
      <div style={{ background: 'gray', height: '350px', width: '800px', borderRadius: '20px', marginTop: '20px' }}>
        <div style={{display:"flex",gap:"10px",justifyContent:"end"}}>
          <select style={{height:"35px",marginTop:'20px',marginRight:"20px",borderRadius:"8px",fontWeight:"bold"}}>
            <option value="yearly">Yearly</option>
            <option value="yearly">2023</option>
            <option value="yearly">2024</option>
            <option value="yearly">2025</option>
          </select>

          <select style={{height:"35px",marginTop:'20px',marginRight:"20px",borderRadius:"8px",fontWeight:"bold"}}>
            <option value="yearly">Monthly</option>
            <option value="yearly">Jan</option>
            <option value="yearly">Feb</option>
            <option value="yearly">Mar</option>
          </select>
          <select style={{height:"35px",marginTop:'20px',marginRight:"20px",borderRadius:"8px",fontWeight:"bold"}}>
            <option value="yearly">Weekly</option>
            <option value="yearly">Sun</option>
            <option value="yearly">Mon</option>
            <option value="yearly">Tues</option>
          </select>
          <select style={{height:"35px",marginTop:'20px',marginRight:"20px",borderRadius:"8px",fontWeight:"bold"}}>
            <option value="yearly">Today</option>
            <option value="yearly">Yesterday</option>
            <option value="yearly">24-05-25</option>
          </select>
          <button style={{height:"35px",marginTop:'20px',marginRight:"20px",borderRadius:"8px",fontWeight:"bold"}}>Export</button>
        </div>
        <hr style={{ border: '2px solid #000', margin: '20px 0' }} />

        <table className="order-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Order ID</th>
              <th>Name</th>
              <th>Category</th>
              <th>Details</th>
              <th>Payment</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Feedback</th>
              <th>Ratings</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <tr key={index}>
                <td>{order.date}</td>
                <td>{order.orderId}</td>
                <td>{order.customerName}</td>
                <td>{order.category}</td>
                <td style={{textDecoration:"underline",color:"bule",cursor:"pointer"}} onClick={() => handleViewClick(order.details)}>View</td>
                <td>{order.paymentMethod}</td>
                <td>{order.status}</td>
                <td>{order.amount}</td>
                <td>{order.Feedback}</td>
                <td>{order.Ratings}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal show={showModal} onClose={() => setShowModal(false)} content={modalContent} />
    </div>
  );
};

export default Closed;
